export default class AdvancedDestinationTabs {
    constructor(advancedSelectorContainer) {
        this._advancedSelectorContainer = advancedSelectorContainer;
        this._resultsContainer = this._advancedSelectorContainer.querySelector(
            '.roi-search-engine__destination-results'
        );
        this.noResultsItemClass = 'roi-search-engine__destination-results-item--no-results';
        this.resultItemClass = 'roi-search-engine__destination-results-item';
        this.resultItemSubtitleClass = 'roi-search-engine__destination-results-item__subtitle';
        this.selectAll = 'js-roi-search-engine-destination-select-all';
        this.tabsSelector = '.js-roi-search-engine-destination-tab';

        this._switchTabs();
    }

    _switchTabs() {
        const tabs = this._advancedSelectorContainer.querySelectorAll(this.tabsSelector);
        tabs.forEach((tab) => {
            tab.addEventListener('click', (event) => { this._toggleTab(event.currentTarget); });
            tab.addEventListener('focus', (event) => { this._toggleTab(event.currentTarget); });
            tab.addEventListener('keydown', (event) => { this._keyboardNavigation(event); });
        });
        if (tabs[0]) {
            tabs[0].click();
        }
    }

    _toggleTab(tab) {
        const activeClass = 'roi-search-engine__destination-menu-item--active',
            previousActiveTab = this._advancedSelectorContainer.querySelector(`.${activeClass}`);
        if (previousActiveTab === tab) {
            return;
        }

        const hiddenContentClass = 'roi-search-engine__destination-results-wrap--hidden',
            { target } = tab.dataset;
        this._resultsContainer.querySelectorAll(`.${hiddenContentClass}`).forEach((choiceGroup) => {
            choiceGroup.classList.remove(hiddenContentClass);
        });

        if (previousActiveTab !== null) {
            previousActiveTab.classList.remove(activeClass);
            previousActiveTab.setAttribute('aria-selected', 'false');
        }
        tab.classList.add(activeClass);
        tab.setAttribute('aria-selected', 'true');
        this._resultsContainer.querySelectorAll(
            `[data-target]:not([data-target=${target}])`
        ).forEach((choiceGroup) => {
            choiceGroup.classList.add(hiddenContentClass);
        });
    }

    _keyboardNavigation(event) {
        if (['Enter', ' ', 'Spacebar'].includes(event.key)) {
            event.preventDefault();
            this._moveFromTabToPanel(event);
        } else if (['ArrowUp', 'ArrowDown', 'Up', 'Down'].includes(event.key)) {
            this._navigateTabsWithArrows(event);
        }
    }

    _moveFromTabToPanel(event) {
        const tab = event.currentTarget,
            panel = this._advancedSelectorContainer.querySelector(
                `#${tab.getAttribute('aria-controls')}`
            ),
            firstAvailableResult = panel.querySelector(
                `.${this.resultItemClass}:not(.${this.noResultsItemClass}`
            );
        if (firstAvailableResult !== null) {
            firstAvailableResult.focus();
        }
    }

    _navigateTabsWithArrows(event) {
        const tab = event.currentTarget,
            tabs = this._advancedSelectorContainer.querySelectorAll(this.tabsSelector),
            tabsCount = tabs.length,
            index = +tab.dataset.index,
            direction = ['ArrowUp', 'Up'].includes(event.key) ? -1 : 1,
            target = (index + direction + tabsCount) % tabsCount;
        this._advancedSelectorContainer.querySelector(
            `${this.tabsSelector}[data-index='${target}']`
        ).focus();
    }
}
